import { State } from '../../reducers/rootReducer'
import ComparisonCarlineStructure from '../../../entities/ComparisonCarlineStructure'

const comparisonCarlineStructureSelector = (state: State): ComparisonCarlineStructure => state.comparisonCarlineStructure

export default comparisonCarlineStructureSelector
